












import {Component, Vue, Ref, Watch} from 'vue-property-decorator';

/**
 * Wrapping component for a scrollable list that stays in place
 */
@Component({
    props: {
        /**
         * Should the items be align to the top
         */
        topAlign: {
            type: Boolean,
            required: false,
            default: false
        }
    }
})
export default class ScrollList extends Vue {

    @Ref('scrolledList') private readonly scrolledList!: any;

    // Whenever te component is re-rendered,
    // Occurs when content is changed
    private updated() {

        // Scroll new item into view
        if (this.$props.topAlign) {
            this.scrollToTop();
        } else {
            this.scrollToBottom();
        }
    }

    private scrollToBottom() {
        this.scrolledList.$el.scrollTop = this.scrolledList.$el.scrollHeight;
    }

    private scrollToTop() {
        this.scrolledList.$el.scrollTop = 0;
    }
}
